// extracted by mini-css-extract-plugin
module.exports =  {"userSelect_none":"_2787e5dfdf--userSelect_none--g_J_6","userSelect_auto":"_2787e5dfdf--userSelect_auto--f5UVj","userSelect_all":"_2787e5dfdf--userSelect_all--v9qxk"};